import * as React from 'react';

import { EnterpriseOrgScopedPageGuard } from 'bundles/unified-common/providers/org-scoped/guards/EnterpriseOrgScopedPageGuard';
import { EnterpriseOrgScopedUserStateCheckWrapper } from 'bundles/unified-common/providers/org-scoped/guards/EnterpriseOrgScopedUserStateCheckWrapper';
import EnterpriseOrgScopedHeaderFooterWrapper from 'bundles/unified-common/providers/org-scoped/layout/EnterpriseOrgScopedHeaderFooterWrapper';
import { EnterpriseOrgScopedPageExtras } from 'bundles/unified-common/providers/org-scoped/layout/EnterpriseOrgScopedPageExtras';
import OrganizationPageTrackingWrapper from 'bundles/unified-home-common/pages/org-scoped/OrganizationPageTrackingWrapper';

const EnterpriseOrgScopedPageTemplateWrapper = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <EnterpriseOrgScopedPageGuard>
      <EnterpriseOrgScopedPageExtras>
        <EnterpriseOrgScopedHeaderFooterWrapper>
          <EnterpriseOrgScopedUserStateCheckWrapper>
            <OrganizationPageTrackingWrapper>{children}</OrganizationPageTrackingWrapper>
          </EnterpriseOrgScopedUserStateCheckWrapper>
        </EnterpriseOrgScopedHeaderFooterWrapper>
      </EnterpriseOrgScopedPageExtras>
    </EnterpriseOrgScopedPageGuard>
  );
};

export default EnterpriseOrgScopedPageTemplateWrapper;
